import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkBadge, UitkBadgeSize, UitkBadgeTheme } from "uitk-react-badge";

import { ProductTypeContext } from "components/flexComponents/TopCities/TopCities";
import { ProductType } from "components/flexComponents/TopCities/utils/topCitiesEnums";

const ProductIcon = () => {
  const productType = React.useContext(ProductTypeContext);
  const { formatText } = useLocalization();

  const iconDescription = {
    hotels: formatText("wizard.hotel.tab.title.label"),
    flights: formatText("wizard.flight.tab.title.label"),
    cars: formatText("wizard.car.tab.title.label"),
  };

  if (productType === ProductType.PACKAGES) {
    return (
      <UitkLayoutPosition type="absolute" position={{ top: "two", left: "two" }}>
        <UitkLayoutFlex>
          <UitkBadge theme={UitkBadgeTheme.NOTIFICATION_2} size={UitkBadgeSize.LARGE}>
            <UitkIcon
              name="lob_flights"
              id="flights"
              title={iconDescription.flights}
              description={iconDescription.flights}
              size={UitkIconSize.SMALL}
            />
          </UitkBadge>

          <UitkSpacing margin={{ inlinestart: "two" }}>
            <UitkBadge theme={UitkBadgeTheme.NOTIFICATION_2} size={UitkBadgeSize.LARGE}>
              <UitkIcon
                name="lob_hotels"
                id="hotels"
                title={iconDescription.hotels}
                description={iconDescription.hotels}
                size={UitkIconSize.SMALL}
              />
            </UitkBadge>
          </UitkSpacing>
        </UitkLayoutFlex>
      </UitkLayoutPosition>
    );
  }

  return (
    <UitkLayoutPosition type="absolute" position={{ top: "two", left: "two" }}>
      <UitkBadge theme={UitkBadgeTheme.NOTIFICATION_2} size={UitkBadgeSize.LARGE}>
        <UitkIcon
          name={`lob_${productType}`}
          id={productType}
          title={iconDescription[productType]}
          description={iconDescription[productType]}
          size={UitkIconSize.SMALL}
        />
      </UitkBadge>
    </UitkLayoutPosition>
  );
};

export default ProductIcon;
